var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-main" },
    [
      _c("div", { staticClass: "vertify-title" }, [_vm._v("认证管理")]),
      _vm._v(" "),
      !_vm.centerInfo
        ? _c("div", { staticClass: "text-color-grey" }, [
            _vm._v("加载失败请稍后重试")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.centerInfo, function(item) {
        return _c(
          "div",
          { key: item.name, staticClass: "vertify-li spaceLeft" },
          [
            _c("div", { staticClass: "vertify-li-title" }, [
              _vm._v(_vm._s(item.header))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "width-auto" },
              [
                item.name !== "aprvSt" || _vm.securityInfo.aprvSt !== "2"
                  ? _c("span", [_vm._v(_vm._s(item.content))])
                  : _c(
                      "a-popover",
                      [
                        _c("template", { slot: "content" }, [
                          _c("h5", [_vm._v("审核意见")]),
                          _vm._v(" "),
                          _c("p", [_vm._v(_vm._s(_vm.aproPopContent))])
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(item.content))])
                      ],
                      2
                    )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                item.remark
                  ? _c("span", [_vm._v(_vm._s(item.remark))])
                  : _vm._e(),
                _vm._v(" "),
                item.modifyText
                  ? _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            item.modifyFlag = !item.modifyFlag
                          }
                        }
                      },
                      [_vm._v(_vm._s(item.modifyText))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                item.routersFlag
                  ? _vm._l(item.routers, function(oper) {
                      return _c(
                        "a",
                        {
                          key: oper.text,
                          on: {
                            click: function($event) {
                              return _vm.toPage(oper.uri)
                            }
                          }
                        },
                        [_vm._v(_vm._s(oper.text))]
                      )
                    })
                  : _vm._e()
              ],
              2
            )
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71c944e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71c944e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/security/vertify/vertify-management.vue
// module id = BTGR
// module chunks = 1